@if (showLabel()) {
    <app-float-label>
        <ng-container *ngTemplateOutlet="inputField"></ng-container>
        <label [for]="id()" class="block">{{ label() | translate }}</label>
    </app-float-label>
} @else {
    <ng-container *ngTemplateOutlet="inputField"></ng-container>
}

<ng-template #inputField>
    <p-autoComplete
        [(ngModel)]="value"
        [inputId]="id()"
        [multiple]="true"
        [suggestions]="filteredSuggestions()"
        [delay]="0"
        [placeholder]="autocompletePlaceholder()"
        [disabled]="disabled()"
        [readonly]="readonly()"
        [invalid]="touched() && invalid()"
        [showClear]="showClear()"
        [showEmptyMessage]="false"
        [class.required-input-border]="required()"
        [class.p-inputwrapper-filled]="hasContent()"
        appendTo="body"
        (input)="inputChanged($event)"
        (onSelect)="selectionChanged()"
        (onUnselect)="selectionChanged()"
        (onClear)="selectionChanged()"
        (completeMethod)="queryChange($event)"
        (onKeyUp)="submitOnEnter($event)"
        (onBlur)="blur()"
    />
</ng-template>
@if (showHelpText()) {
    <small>{{ helpText() | translate }}</small>
}
<app-input-error [errors]="errors()" [touched]="touched()"></app-input-error>
